<div class="iframe-container">

<h2>SISTEMA DE GESTIÓN DE IGUALDAD DE GÉNERO Y NO DISCRIMINACIÓN (SGIG). </h2>

  <iframe 
    src="https://www.tecnm.mx/?vista=Sistema_Gestion_Igualdad"
    width="900px" 
    height="700px"
    frameborder="0">
  </iframe>
</div>